import PageTypeB from "../../components/pageTypeB/PageTypeB";
import styles from "./Page2.module.css";
import { pagesDataB } from "../../data/pagesData";

const Page2 = () => {
  return (
    <div className={styles.main}>
      <div className={styles.wrapper}>
        <PageTypeB
          title={pagesDataB[0].title}
          paragraph1={pagesDataB[0].paragraph1}
          paragraph2={pagesDataB[0].paragraph2}
          paragraph3={pagesDataB[0].paragraph3}
        />
        <div className={styles.listWrapper}>
          <h3 className={styles.listTitle}>Wir verbinden:</h3>
          <ul className={styles.list}>
            <li>
              <p>
                Vier komplementäre Ernährungsansätze zu einem synergetischen
                Gesamtprogramm.
              </p>
            </li>
            <li>
              <p>
                Mentale und körperorientierte Methoden, die wissenschaftlich
                belegt und ganzheitlich erprobt sind.
              </p>
            </li>
            <li>
              <p>
                Individuelle Anpassung, abgestimmt auf Ihre Lebenssituation,
                Ziele und Bedürfnisse.
              </p>
            </li>
          </ul>
        </div>
        <div className={styles.btnWrapper}>
          <button className={styles.btn}>
            <h4>Ernährung</h4>
          </button>
          <button className={styles.btn}>
            <h4>Mentale Techniken</h4>
          </button>
          <button className={styles.btn}>
            <h4>Körperarbeit</h4>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Page2;
